import * as React from "react"
import * as ReactDom from "react-dom"
import * as Bouncer from "formbouncerjs";
import Participar from "../components/views/participanteform";
import { emails } from "../config/constants";
import { checkLang, setCurrentPage } from "../services/general";
import { requestPageData } from "../services/api";

export const page = async () => {
    const participarContainer = document.getElementById('participanteForm')
    const PARTICIPARINFO = window.drupalSettings.react.node || await requestPageData({ content: "partner", nid: participarContainer.dataset.nid, langcode: checkLang() })
    ReactDom.render(<Participar  data={PARTICIPARINFO} />, participarContainer)
    setNewForm();
    setCurrentPage('login');
    previwImage();
    validateForm();
}

function setNewForm() {
    const refForm = document.getElementById('refFormParticipante')
    const refNewForm = document.getElementById('newFormParticipante')

    refNewForm.insertAdjacentElement('beforeend', refForm.children[0])

    insertSubtitleForm();
    refForm.remove()
}

const insertSubtitleForm = () => {
    let container = document.querySelector('#newFormParticipante .form-item-draw-title') as any;
    container.insertAdjacentHTML('afterbegin', '<h2 class="form__title">2. SUBE TU DIBUJO</h2>')
}

const previwImage = () => {
    let inputFile = document.querySelector('#edit-drawing') as any;
    let imgPreview = document.querySelector('#imageRef') as any;
    let label = document.querySelector('label[for="edit-drawing"]') as any;
    let titleImage = document.querySelector('#nameImageRef') as any;
    let sizeImage = document.querySelector('#sizeImageRef') as any;
    
    inputFile.addEventListener("change", () => {
        const [file]: any = inputFile.files;
        if (file) {
            imgPreview.src = URL.createObjectURL(file);
            titleImage.textContent = file.name
            sizeImage.textContent = convertBytes(file.size)
            label.classList.add('af-picture--preparated');
            removeImage();
        }
    });

    const convertBytes = (bytes: number) => {
        if (bytes > 1_000_000) {
            let kilobytes = bytes / 1024
            return `${Math.round(kilobytes / 1024)}MB`
        }
        return `${Math.round(bytes / 1024)}KB`
    }
}

const removeImage = () => {
    let label = document.querySelector('label[for="edit-drawing"]') as any;
    let btnRemove = document.querySelector('.af-picture__remove') as any;
    let inputFile = document.querySelector('#edit-drawing') as any;
    btnRemove.addEventListener("click", (e:any) => {
        e.preventDefault();
        label.classList.remove('af-picture--preparated');
        inputFile.value = '';
        previwImage();
    });
}

function validateForm() {
    let validationsMessages: any = {
        field: 'Campo Obligatorio',
        file: 'Sube una imagen',
    }
    var validate = Bouncer("#mx-aguas-firmes-participate-form", {
        patterns: {
            email:
                /^[a-z0-9!#$%&'*/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/,
        },
        customValidations: {
            emailVerified: function (field: any) {
                let array_email = field.value.split("@");
                const res = emails.find((m) => m === array_email[1]);
                return res === undefined ? false : true;
            },
            fileVerified: function (field: any) {
                if (field.name == "files[drawing]") {
                    const value = field.value;
                    if (value.length == 0) {
                        return true;
                    }
                }
            }
        },
        messages: {
            missingValue: {
                default: validationsMessages.field,
                checkbox: validationsMessages.tyc,
            },
            emailVerified: validationsMessages.email,
            fileVerified: validationsMessages.file,
            anotherVerified: validationsMessages.field,
            patternMismatch: {
                email: validationsMessages.email,
            },
        },
    });
}